import { render } from "./EmptyIcon.vue?vue&type=template&id=18723831"
import script from "./EmptyIcon.vue?vue&type=script&lang=js"
export * from "./EmptyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/EmptyIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18723831"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18723831', __exports__)) {
    api.reload('18723831', __exports__)
  }
  
  module.hot.accept("./EmptyIcon.vue?vue&type=template&id=18723831", () => {
    api.rerender('18723831', render)
  })

}


export default __exports__